/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { Organization } from '../model';
// @ts-ignore
import type { OrganizationAIQuotaStatus } from '../model';
// @ts-ignore
import type { OrganizationAIQuotaSummary } from '../model';
// @ts-ignore
import type { OrganizationAIQuotaUpdate } from '../model';
// @ts-ignore
import type { OrganizationConfig } from '../model';
// @ts-ignore
import type { OrganizationConfigOverride } from '../model';
// @ts-ignore
import type { OrganizationConfigUpdate } from '../model';
// @ts-ignore
import type { OrganizationConfigUpdateRisk } from '../model';
// @ts-ignore
import type { OrganizationCreate } from '../model';
// @ts-ignore
import type { OrganizationInternalUpdate } from '../model';
// @ts-ignore
import type { OrganizationMetricsPaginated } from '../model';
// @ts-ignore
import type { OrganizationMetricsSorting } from '../model';
// @ts-ignore
import type { OrganizationQuota } from '../model';
// @ts-ignore
import type { OrganizationSsoStatus } from '../model';
// @ts-ignore
import type { OrganizationUpdate } from '../model';
// @ts-ignore
import type { OrganizationsOverview } from '../model';
/**
 * OrganizationsApi - axios parameter creator
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Configure Organization Ai Quota
         * @param {string} organizationId 
         * @param {OrganizationAIQuotaUpdate} organizationAIQuotaUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureOrganizationAiQuota: async (organizationId: string, organizationAIQuotaUpdate: OrganizationAIQuotaUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('configureOrganizationAiQuota', 'organizationId', organizationId)
            // verify required parameter 'organizationAIQuotaUpdate' is not null or undefined
            assertParamExists('configureOrganizationAiQuota', 'organizationAIQuotaUpdate', organizationAIQuotaUpdate)
            const localVarPath = `/organizations/{organization_id}/ai-quota`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationAIQuotaUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new organization with default configuration.
         * @summary Create Organization
         * @param {OrganizationCreate} organizationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization: async (organizationCreate: OrganizationCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationCreate' is not null or undefined
            assertParamExists('createOrganization', 'organizationCreate', organizationCreate)
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an organization and all associated data.
         * @summary Delete Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get organization by ID.
         * @summary Get Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Ai Quota
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAiQuota: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationAiQuota', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}/ai-quota`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Ai Quota Details
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAiQuotaDetails: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationAiQuotaDetails', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}/ai-quota/details`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Config
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationConfig: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationConfig', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}/config`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The plan\'s limits next to what the organization uses: AI Systems that left Draft, and active users.
         * @summary Get Organization Quota
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationQuota: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationQuota', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}/quota`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read an organization\'s current single sign-on configuration live from the IdP.
         * @summary Get Organization Sso Status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSsoStatus: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationSsoStatus', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}/sso`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return each organization\'s users and AI Systems against its plan quota.
         * @summary Get Organizations Metrics
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationMetricsSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsMetrics: async (page?: number, size?: number, sortBy?: OrganizationMetricsSorting | null, descending?: boolean | null, name?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return aggregated metrics across all organizations, including the SSO-enabled count.
         * @summary Get Organizations Overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/metrics/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Override Organization Config
         * @param {string} organizationId 
         * @param {OrganizationConfigOverride} organizationConfigOverride 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideOrganizationConfig: async (organizationId: string, organizationConfigOverride: OrganizationConfigOverride, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('overrideOrganizationConfig', 'organizationId', organizationId)
            // verify required parameter 'organizationConfigOverride' is not null or undefined
            assertParamExists('overrideOrganizationConfig', 'organizationConfigOverride', organizationConfigOverride)
            const localVarPath = `/organizations/{organization_id}/config`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationConfigOverride, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update organization name and description.
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {OrganizationUpdate} organizationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization: async (organizationId: string, organizationUpdate: OrganizationUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganization', 'organizationId', organizationId)
            // verify required parameter 'organizationUpdate' is not null or undefined
            assertParamExists('updateOrganization', 'organizationUpdate', organizationUpdate)
            const localVarPath = `/organizations/{organization_id}`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Organization Config
         * @param {string} organizationId 
         * @param {OrganizationConfigUpdate} organizationConfigUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationConfig: async (organizationId: string, organizationConfigUpdate: OrganizationConfigUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganizationConfig', 'organizationId', organizationId)
            // verify required parameter 'organizationConfigUpdate' is not null or undefined
            assertParamExists('updateOrganizationConfig', 'organizationConfigUpdate', organizationConfigUpdate)
            const localVarPath = `/organizations/{organization_id}/config`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationConfigUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Organization Config Risk
         * @param {string} organizationId 
         * @param {OrganizationConfigUpdateRisk} organizationConfigUpdateRisk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationConfigRisk: async (organizationId: string, organizationConfigUpdateRisk: OrganizationConfigUpdateRisk, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganizationConfigRisk', 'organizationId', organizationId)
            // verify required parameter 'organizationConfigUpdateRisk' is not null or undefined
            assertParamExists('updateOrganizationConfigRisk', 'organizationConfigUpdateRisk', organizationConfigUpdateRisk)
            const localVarPath = `/organizations/{organization_id}/config/risk`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationConfigUpdateRisk, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update whether an organization is internal to Modulos.
         * @summary Update Organization Internal Status
         * @param {string} organizationId Organization ID.
         * @param {OrganizationInternalUpdate} organizationInternalUpdate The organization\&#39;s new internal status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationInternalStatus: async (organizationId: string, organizationInternalUpdate: OrganizationInternalUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganizationInternalStatus', 'organizationId', organizationId)
            // verify required parameter 'organizationInternalUpdate' is not null or undefined
            assertParamExists('updateOrganizationInternalStatus', 'organizationInternalUpdate', organizationInternalUpdate)
            const localVarPath = `/organizations/{organization_id}/internal-status`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationInternalUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Configure Organization Ai Quota
         * @param {string} organizationId 
         * @param {OrganizationAIQuotaUpdate} organizationAIQuotaUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configureOrganizationAiQuota(organizationId: string, organizationAIQuotaUpdate: OrganizationAIQuotaUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAIQuotaStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configureOrganizationAiQuota(organizationId, organizationAIQuotaUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.configureOrganizationAiQuota']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new organization with default configuration.
         * @summary Create Organization
         * @param {OrganizationCreate} organizationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganization(organizationCreate: OrganizationCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganization(organizationCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an organization and all associated data.
         * @summary Delete Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganization(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deleteOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get organization by ID.
         * @summary Get Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Organization Ai Quota
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationAiQuota(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAIQuotaSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationAiQuota(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationAiQuota']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Organization Ai Quota Details
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationAiQuotaDetails(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAIQuotaStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationAiQuotaDetails(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationAiQuotaDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Organization Config
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationConfig(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationConfig(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The plan\'s limits next to what the organization uses: AI Systems that left Draft, and active users.
         * @summary Get Organization Quota
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationQuota(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationQuota>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationQuota(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationQuota']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read an organization\'s current single sign-on configuration live from the IdP.
         * @summary Get Organization Sso Status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationSsoStatus(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationSsoStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationSsoStatus(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationSsoStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return each organization\'s users and AI Systems against its plan quota.
         * @summary Get Organizations Metrics
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationMetricsSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsMetrics(page?: number, size?: number, sortBy?: OrganizationMetricsSorting | null, descending?: boolean | null, name?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationMetricsPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsMetrics(page, size, sortBy, descending, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationsMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return aggregated metrics across all organizations, including the SSO-enabled count.
         * @summary Get Organizations Overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationsOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Override Organization Config
         * @param {string} organizationId 
         * @param {OrganizationConfigOverride} organizationConfigOverride 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideOrganizationConfig(organizationId: string, organizationConfigOverride: OrganizationConfigOverride, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideOrganizationConfig(organizationId, organizationConfigOverride, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.overrideOrganizationConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update organization name and description.
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {OrganizationUpdate} organizationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganization(organizationId: string, organizationUpdate: OrganizationUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganization(organizationId, organizationUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Organization Config
         * @param {string} organizationId 
         * @param {OrganizationConfigUpdate} organizationConfigUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationConfig(organizationId: string, organizationConfigUpdate: OrganizationConfigUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationConfig(organizationId, organizationConfigUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateOrganizationConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Organization Config Risk
         * @param {string} organizationId 
         * @param {OrganizationConfigUpdateRisk} organizationConfigUpdateRisk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationConfigRisk(organizationId: string, organizationConfigUpdateRisk: OrganizationConfigUpdateRisk, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationConfigRisk(organizationId, organizationConfigUpdateRisk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateOrganizationConfigRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update whether an organization is internal to Modulos.
         * @summary Update Organization Internal Status
         * @param {string} organizationId Organization ID.
         * @param {OrganizationInternalUpdate} organizationInternalUpdate The organization\&#39;s new internal status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationInternalStatus(organizationId: string, organizationInternalUpdate: OrganizationInternalUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationInternalStatus(organizationId, organizationInternalUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateOrganizationInternalStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Configure Organization Ai Quota
         * @param {OrganizationsApiConfigureOrganizationAiQuotaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureOrganizationAiQuota(requestParameters: OrganizationsApiConfigureOrganizationAiQuotaRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationAIQuotaStatus> {
            return localVarFp.configureOrganizationAiQuota(requestParameters.organizationId, requestParameters.organizationAIQuotaUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new organization with default configuration.
         * @summary Create Organization
         * @param {OrganizationsApiCreateOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(requestParameters: OrganizationsApiCreateOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.createOrganization(requestParameters.organizationCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an organization and all associated data.
         * @summary Delete Organization
         * @param {OrganizationsApiDeleteOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization(requestParameters: OrganizationsApiDeleteOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get organization by ID.
         * @summary Get Organization
         * @param {OrganizationsApiGetOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(requestParameters: OrganizationsApiGetOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.getOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Ai Quota
         * @param {OrganizationsApiGetOrganizationAiQuotaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAiQuota(requestParameters: OrganizationsApiGetOrganizationAiQuotaRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationAIQuotaSummary> {
            return localVarFp.getOrganizationAiQuota(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Ai Quota Details
         * @param {OrganizationsApiGetOrganizationAiQuotaDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAiQuotaDetails(requestParameters: OrganizationsApiGetOrganizationAiQuotaDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationAIQuotaStatus> {
            return localVarFp.getOrganizationAiQuotaDetails(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Config
         * @param {OrganizationsApiGetOrganizationConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationConfig(requestParameters: OrganizationsApiGetOrganizationConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationConfig> {
            return localVarFp.getOrganizationConfig(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * The plan\'s limits next to what the organization uses: AI Systems that left Draft, and active users.
         * @summary Get Organization Quota
         * @param {OrganizationsApiGetOrganizationQuotaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationQuota(requestParameters: OrganizationsApiGetOrganizationQuotaRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationQuota> {
            return localVarFp.getOrganizationQuota(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read an organization\'s current single sign-on configuration live from the IdP.
         * @summary Get Organization Sso Status
         * @param {OrganizationsApiGetOrganizationSsoStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSsoStatus(requestParameters: OrganizationsApiGetOrganizationSsoStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationSsoStatus> {
            return localVarFp.getOrganizationSsoStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return each organization\'s users and AI Systems against its plan quota.
         * @summary Get Organizations Metrics
         * @param {OrganizationsApiGetOrganizationsMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsMetrics(requestParameters: OrganizationsApiGetOrganizationsMetricsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationMetricsPaginated> {
            return localVarFp.getOrganizationsMetrics(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Return aggregated metrics across all organizations, including the SSO-enabled count.
         * @summary Get Organizations Overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOverview(options?: RawAxiosRequestConfig): AxiosPromise<OrganizationsOverview> {
            return localVarFp.getOrganizationsOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Override Organization Config
         * @param {OrganizationsApiOverrideOrganizationConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideOrganizationConfig(requestParameters: OrganizationsApiOverrideOrganizationConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationConfig> {
            return localVarFp.overrideOrganizationConfig(requestParameters.organizationId, requestParameters.organizationConfigOverride, options).then((request) => request(axios, basePath));
        },
        /**
         * Update organization name and description.
         * @summary Update Organization
         * @param {OrganizationsApiUpdateOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(requestParameters: OrganizationsApiUpdateOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.updateOrganization(requestParameters.organizationId, requestParameters.organizationUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Organization Config
         * @param {OrganizationsApiUpdateOrganizationConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationConfig(requestParameters: OrganizationsApiUpdateOrganizationConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationConfig> {
            return localVarFp.updateOrganizationConfig(requestParameters.organizationId, requestParameters.organizationConfigUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Organization Config Risk
         * @param {OrganizationsApiUpdateOrganizationConfigRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationConfigRisk(requestParameters: OrganizationsApiUpdateOrganizationConfigRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationConfig> {
            return localVarFp.updateOrganizationConfigRisk(requestParameters.organizationId, requestParameters.organizationConfigUpdateRisk, options).then((request) => request(axios, basePath));
        },
        /**
         * Update whether an organization is internal to Modulos.
         * @summary Update Organization Internal Status
         * @param {OrganizationsApiUpdateOrganizationInternalStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationInternalStatus(requestParameters: OrganizationsApiUpdateOrganizationInternalStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.updateOrganizationInternalStatus(requestParameters.organizationId, requestParameters.organizationInternalUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for configureOrganizationAiQuota operation in OrganizationsApi.
 */
export interface OrganizationsApiConfigureOrganizationAiQuotaRequest {
    readonly organizationId: string

    readonly organizationAIQuotaUpdate: OrganizationAIQuotaUpdate
}

/**
 * Request parameters for createOrganization operation in OrganizationsApi.
 */
export interface OrganizationsApiCreateOrganizationRequest {
    readonly organizationCreate: OrganizationCreate
}

/**
 * Request parameters for deleteOrganization operation in OrganizationsApi.
 */
export interface OrganizationsApiDeleteOrganizationRequest {
    readonly organizationId: string
}

/**
 * Request parameters for getOrganization operation in OrganizationsApi.
 */
export interface OrganizationsApiGetOrganizationRequest {
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationAiQuota operation in OrganizationsApi.
 */
export interface OrganizationsApiGetOrganizationAiQuotaRequest {
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationAiQuotaDetails operation in OrganizationsApi.
 */
export interface OrganizationsApiGetOrganizationAiQuotaDetailsRequest {
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationConfig operation in OrganizationsApi.
 */
export interface OrganizationsApiGetOrganizationConfigRequest {
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationQuota operation in OrganizationsApi.
 */
export interface OrganizationsApiGetOrganizationQuotaRequest {
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationSsoStatus operation in OrganizationsApi.
 */
export interface OrganizationsApiGetOrganizationSsoStatusRequest {
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationsMetrics operation in OrganizationsApi.
 */
export interface OrganizationsApiGetOrganizationsMetricsRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: OrganizationMetricsSorting | null

    readonly descending?: boolean | null

    readonly name?: string | null
}

/**
 * Request parameters for overrideOrganizationConfig operation in OrganizationsApi.
 */
export interface OrganizationsApiOverrideOrganizationConfigRequest {
    readonly organizationId: string

    readonly organizationConfigOverride: OrganizationConfigOverride
}

/**
 * Request parameters for updateOrganization operation in OrganizationsApi.
 */
export interface OrganizationsApiUpdateOrganizationRequest {
    readonly organizationId: string

    readonly organizationUpdate: OrganizationUpdate
}

/**
 * Request parameters for updateOrganizationConfig operation in OrganizationsApi.
 */
export interface OrganizationsApiUpdateOrganizationConfigRequest {
    readonly organizationId: string

    readonly organizationConfigUpdate: OrganizationConfigUpdate
}

/**
 * Request parameters for updateOrganizationConfigRisk operation in OrganizationsApi.
 */
export interface OrganizationsApiUpdateOrganizationConfigRiskRequest {
    readonly organizationId: string

    readonly organizationConfigUpdateRisk: OrganizationConfigUpdateRisk
}

/**
 * Request parameters for updateOrganizationInternalStatus operation in OrganizationsApi.
 */
export interface OrganizationsApiUpdateOrganizationInternalStatusRequest {
    /**
     * Organization ID.
     */
    readonly organizationId: string

    /**
     * The organization\&#39;s new internal status.
     */
    readonly organizationInternalUpdate: OrganizationInternalUpdate
}

/**
 * OrganizationsApi - object-oriented interface
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * 
     * @summary Configure Organization Ai Quota
     * @param {OrganizationsApiConfigureOrganizationAiQuotaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public configureOrganizationAiQuota(requestParameters: OrganizationsApiConfigureOrganizationAiQuotaRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).configureOrganizationAiQuota(requestParameters.organizationId, requestParameters.organizationAIQuotaUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new organization with default configuration.
     * @summary Create Organization
     * @param {OrganizationsApiCreateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrganization(requestParameters: OrganizationsApiCreateOrganizationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createOrganization(requestParameters.organizationCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an organization and all associated data.
     * @summary Delete Organization
     * @param {OrganizationsApiDeleteOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOrganization(requestParameters: OrganizationsApiDeleteOrganizationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get organization by ID.
     * @summary Get Organization
     * @param {OrganizationsApiGetOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganization(requestParameters: OrganizationsApiGetOrganizationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Ai Quota
     * @param {OrganizationsApiGetOrganizationAiQuotaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationAiQuota(requestParameters: OrganizationsApiGetOrganizationAiQuotaRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationAiQuota(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Ai Quota Details
     * @param {OrganizationsApiGetOrganizationAiQuotaDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationAiQuotaDetails(requestParameters: OrganizationsApiGetOrganizationAiQuotaDetailsRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationAiQuotaDetails(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Config
     * @param {OrganizationsApiGetOrganizationConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationConfig(requestParameters: OrganizationsApiGetOrganizationConfigRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationConfig(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The plan\'s limits next to what the organization uses: AI Systems that left Draft, and active users.
     * @summary Get Organization Quota
     * @param {OrganizationsApiGetOrganizationQuotaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationQuota(requestParameters: OrganizationsApiGetOrganizationQuotaRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationQuota(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read an organization\'s current single sign-on configuration live from the IdP.
     * @summary Get Organization Sso Status
     * @param {OrganizationsApiGetOrganizationSsoStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationSsoStatus(requestParameters: OrganizationsApiGetOrganizationSsoStatusRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationSsoStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return each organization\'s users and AI Systems against its plan quota.
     * @summary Get Organizations Metrics
     * @param {OrganizationsApiGetOrganizationsMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationsMetrics(requestParameters: OrganizationsApiGetOrganizationsMetricsRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationsMetrics(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return aggregated metrics across all organizations, including the SSO-enabled count.
     * @summary Get Organizations Overview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationsOverview(options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationsOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Override Organization Config
     * @param {OrganizationsApiOverrideOrganizationConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public overrideOrganizationConfig(requestParameters: OrganizationsApiOverrideOrganizationConfigRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).overrideOrganizationConfig(requestParameters.organizationId, requestParameters.organizationConfigOverride, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update organization name and description.
     * @summary Update Organization
     * @param {OrganizationsApiUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganization(requestParameters: OrganizationsApiUpdateOrganizationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganization(requestParameters.organizationId, requestParameters.organizationUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Organization Config
     * @param {OrganizationsApiUpdateOrganizationConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationConfig(requestParameters: OrganizationsApiUpdateOrganizationConfigRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganizationConfig(requestParameters.organizationId, requestParameters.organizationConfigUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Organization Config Risk
     * @param {OrganizationsApiUpdateOrganizationConfigRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationConfigRisk(requestParameters: OrganizationsApiUpdateOrganizationConfigRiskRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganizationConfigRisk(requestParameters.organizationId, requestParameters.organizationConfigUpdateRisk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update whether an organization is internal to Modulos.
     * @summary Update Organization Internal Status
     * @param {OrganizationsApiUpdateOrganizationInternalStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationInternalStatus(requestParameters: OrganizationsApiUpdateOrganizationInternalStatusRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganizationInternalStatus(requestParameters.organizationId, requestParameters.organizationInternalUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

